import * as example from './example/actions';

export const setActions = {
	//
	example,
};
